import React from "react";
import { StyleProp, TouchableOpacity, ViewStyle } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { DrawerActions, useNavigation } from "@react-navigation/native";

type Props = {
  iconColor?: string;
  iconSize?: number;
  style?: StyleProp<ViewStyle> | undefined;
};

function DrawerMenuButton({
  iconColor = "#F2F2F7",
  iconSize = 24,
  style = undefined,
}: Props): React.JSX.Element {
  const navigation = useNavigation();

  return (
    <TouchableOpacity
      style={style}
      hitSlop={8}
      onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
    >
      <Ionicons
        testID="header-menu-icon"
        name="menu-outline"
        size={iconSize}
        color={iconColor}
      />
    </TouchableOpacity>
  );
}

export default DrawerMenuButton;
